import axios from './axios.js'

// 代币套餐
export function packageListData(limit, page, goodsTypeSonId,uids,orderNo,shopId,endDate,startDate) {
    return axios.get(`order_mall/list_data?limit=${limit}&page=${page}&goodsTypeSonId=${goodsTypeSonId}&userUid=${uids}&orderNo=${orderNo}&shopId=${shopId}&endDate=${endDate}&startDate=${startDate}`)
}
// 代币套餐查询
export function packageListDataSeach(limit, page, goodsTypeSonId,uids,orderNo,shopId,endDate,startDate) {
    return axios.get(`order_mall/list_data?limit=${limit}&page=${page}&goodsTypeSonId=${goodsTypeSonId}&userUid=${uids}&orderNo=${orderNo}&shopId=${shopId}&endDate=${endDate}&startDate=${startDate}`)
}

// 已支付订单
export function alreadyPay(limit, page,uids,orderNo,shopId,endDate,startDate) {
    return axios.get(`order_mall/list_data?limit=${limit}&page=${page}&userUid=${uids}&orderNo=${orderNo}&shopId=${shopId}&endDate=${endDate}&startDate=${startDate}&statusUser=${1401}`)
}
// 已支付订单
export function alreadyPaySeach(limit, page,uids,orderNo,shopId,endDate,startDate) {
    return axios.get(`order_mall/list_data?limit=${limit}&page=${page}&userUid=${uids}&orderNo=${orderNo}&shopId=${shopId}&endDate=${endDate}&startDate=${startDate}&statusUser=${1401}`)
}


// 按套餐统计
export function packageStatistics(goodsType,storeId,endDate,startDate,pageNo,pageSize) {
    return axios.get(`order_goods_count/list_data?goodsType=${goodsType}&storeId=${storeId}&endDate=${endDate}&startDate=${startDate}&pageNo=${pageNo}&pageSize=${pageSize}`)
}


// WEBPACK FOOTER //
// ./src/api/packageApi.js